export const REQUEST_STATUS_OPTIONS = [
  { label: 'Bozza', value: 'BOZ' },
  { label: 'Nuova', value: 'NEW' },
  { label: 'Presa in carico', value: 'PIC' },
  { label: 'Scelta struttura', value: 'SS' },
  { label: 'In conferma paziente', value: 'CP' },
  { label: 'In conferma struttura', value: 'CS' },
  { label: 'Completata', value: 'END' },
  { label: 'Annullata', value: 'DEL' },
  { label: 'Primo sollecito', value: 'SOL1' },
  { label: 'Secondo sollecito', value: 'SOL2' },
  { label: 'Terzo sollecito', value: 'SOL3' },
  { label: 'Aperta', value: 'APE' },
  { label: 'Da Trasmettere', value: 'DAT' },
  { label: 'Trasmessa', value: 'TPV' },
  { label: 'Trasmessa per Arruolamento', value: 'TPA' },
  { label: 'Valutata', value: 'VAL' },
  { label: 'Arruolamento', value: 'CPZ' },
  { label: 'Arruolata', value: 'CST' },
  { label: 'Chiusa', value: 'CHI' },
];
